import { Component, OnDestroy, OnInit } from '@angular/core';
import {BaseView} from '../../../base-view';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {Filtering} from '../../../../service/filtering/filtering';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {Utils} from '../../../../common/utils';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { TareasApiService } from 'src/app/service/api/tareas-api.service';
import { environment } from 'src/environments/environment';

import { CosteModel } from 'src/app/models/coste.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { build, stack } from 'src/app/common/classes/request-builder';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DropdownData, FormType } from '@fitogest/reactive-form-builder/interfaces';
import { FormControl } from '@angular/forms';
import { CostesTareasFormDefinition } from './form-control/form-definition';

pdfMake.vfs = pdfFonts.vfs;
@Component({
    selector: 'app-costes-tareas',
    standalone: false,
    templateUrl: './costes-tareas.component.html',
    styleUrls: ['./costes-tareas.component.scss']
})
export class CostesTareasComponent extends BaseView<CosteModel> implements OnInit, OnDestroy {
    public getRequest: RequestHandler<CosteModel[]> = this.tareasApi.costes.GET;
    public getInformesRequest: RequestHandler<CosteModel[]> = this.tareasApi.costes.GET_InformeTrabajadores;
    public getInformesMaquinariaRequest: RequestHandler<CosteModel[]> = this.tareasApi.costes.GET_InformeMaquinarias;
    public deleteRequest: RequestHandler<CosteModel> = this.tareasApi.otras.DELETE as unknown as RequestHandler<CosteModel>;
    public menuItemId = 'costes-tareas';


    public fincaName = environment.features.fincaName;
    public fincasName = environment.features.fincasName;
    public appName = environment.appName;
    public showCostesTareasOtrasCsv = environment.features.showCostesTareasOtrasCsv;
    public override canShow: Record<string, boolean> = {};
    public override model: CosteModel = {};
    public ps = 0;

    public mostrarTratamientosAplicados = true;
    public override filtering: Filtering<CosteModel> = new Filtering<CosteModel>();

    public form: CostesTareasFormDefinition | null = null;
    public readonly serverUrl = environment.serverUrl;
    public trabajadores: DropdownData<MantenimientoModel> = {
        values: [],
        filtered: [],
    };

    public selectedTrabajadorControl = new FormControl<MantenimientoModel | null>(null);
    public generarMesControl = new FormControl<Date>(new Date(), { nonNullable: true });
    public generarAnyoControl = new FormControl<Date>(new Date(), { nonNullable: true });

    public cols: ColInterface[] = [
        {field: 'fecha', header: 'Fecha'},
        {field: 'finca', header: this.fincaName, visible: this.appName === 'ava' ? false : true},
        {field: 'parcelas', header: 'Parcelas', visible: this.appName === 'ava' ? true : false},
        {field: 'tarea', header: 'Tarea'},
        {field: 'trabajadores_nombres', header: 'Trabajadores'},
        {field: 'maquinaria', header: 'Maquinaria'},
        {field: 'precio_hora_maquinaria', header: 'Coste (Maq.)'},
        {field: 'precio_cargo', header: 'Coste (Trab.)'},
        {field: 'horas', header: 'Horas', width: '60px'},
        {header: 'Total (Maq.)', field: this.appName === 'ava' ? 'precio_total' : 'maquinaria_precio_total', filter: '', footer: '0'},
        {header: 'Total (Trab.)', field: 'coste' , filter: '', footer: '0'},
        {header: 'Concepto', field: 'concepto' , filter: '', footer: '0', visible: this.appName === 'mbcpomelos'},
        {header: 'Proveedor', field: 'proveedor' , filter: '', footer: '0', visible: this.appName === 'mbcpomelos'},
        {header: 'Costes Subcontratos', field: 'coste_subcontrata' , filter: '', footer: '0', visible: this.appName === 'mbcpomelos'},
        {header: 'Costes Total', field: 'coste_total' , filter: '', footer: '0'},

    ];
    auxTotalTrabajadores = 0;
    showTarea = false;
    showTareaFito = false;
    showTareaFerti = false;

 
    constructor(public tareasApi: TareasApiService,
        public trabajadoresApi: TrabajadoresApiService,
        private dashboard: DashboardService) {
        super(dashboard, tareasApi.costes.GET);
    }

    ngOnInit() {
        this.dashboard.setSubmenuItem('costes', this.menuItemId);

        stack([
            build(this.trabajadoresApi.trabajadoresGET, this.trabajadores, 'nombre', true),
        ]).catch (e => {
            console.log('catch en getPosition: ' + e);
        }

        );
        this.filtering.addFilter((copy: TreeNode<CosteModel>[] | void) => {
            this.updateFooter();
            return (copy as TreeNode<CosteModel>[]).filter(row => row);
        });

        this.filtering.addFilter((data: TreeNode<CosteModel>[] | void) => (data as TreeNode<CosteModel>[]).sort((a, b) =>
            parseInt(a.data?.id ?? '', 10) > parseInt(b.data?.id ?? '', 10) ? -1 : 1
        ));
    }

    public moneyFormat(input: number) {
        return Utils.decimalFormat(input, 2);
    }

    public cuantityFormat(input: number) {
        return Utils.decimalFormat(input, 1);
    }

    public override show(modal: string, data: CosteModel): void {
        let x;

        this.model = { ...data };

        const tareaValue = this.model['tarea'];

        this.tipoTarea(typeof tareaValue === 'string' ? tareaValue : String(tareaValue ?? ''));
        this.canShow[modal] = true;

        if (modal === 'info' || modal === 'delete') {
            const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

            this.form = new CostesTareasFormDefinition(formType);
        }

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x]) {
                this.canShow[x] = false;
            }
        }
    }

    public override hide(modal: string): void {
        this.model = {};
        this.canShow[modal] = false;
        this.deleteRequest.reset();

        if (modal === 'info' || modal === 'delete') {
            this.form = null;
        }
    }

    public override sum(field: string) {
        let sum = 0;
    
        (this.filtering.value as CosteModel[]).forEach(it => {
            if (field === 'horas') {
                const timeParts = (it[field] as string || '0:00').split(':');
                if (timeParts.length === 2) {
                    const hours = parseFloat(timeParts[0] ?? '') || 0;
                    const minutes = parseFloat(timeParts[1] ?? '') || 0;
                    sum += hours + (minutes / 60);
                }
            } else {
                sum += (parseFloat(it[field] as string) || 0);
            }
        });
    
        sum = Math.round(sum * 100) / 100;
    
        this.cols.forEach(it => {
            if (it.field === field) {
                it['footer'] = sum + '';
            }
        });
    }
    
    

    public override updateFooter() {
        ['cantidad', 'horas', 'coste', 'maquinaria_precio_total', 'coste_total', 'coste_subcontrata'].forEach(it => this.sum(it));
        ['precio_total'].forEach(it => this.sum(it));
    }


    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if (
            Utils.isNumber(value) || 
            ['cantidad', 'producto_precio', 'horas', 'coste', 'precio_total', 'coste_total', 'coste_subcontrata'].includes(col.field)
        ) {
            return {
                textAlign: 'center'
            };
        }
        return {};
    }

    public globalVisualTransform(value: string, col: ColInterface) {
        if (
            Utils.isNumber(value) && 
            [
                'producto_precio', 
                'coste', 
                'precio_hora_maquinaria', 
                'precio_cargo', 
                'precio_total',
                'maquinaria_precio_total', 
                'coste_total', 
                'coste_subcontrata'].includes(col.field)
        ) {
            return Utils.decimalFormat(value, 2);
        } else {
            return value;
        }
    }


    public override ngOnDestroy() {
        Utils.unsuscribe([
            this.tareasApi.costes.GET,
        ]);
    }

    public transformStringToNumber( value: string ): number {
        if ( value == null || value.length === 0  ) {
            return 0;
        }
        return parseFloat(value);
    }

    public sumaAuxTrabajadores( horas: string ) {
        const trabajadores: MantenimientoModel[] | null = this.model.lista_trabajadores ?? null;
        let suma =  0;
        if ( trabajadores == null ) {
            return suma;
        }
        for (const trabajador of trabajadores) {
            if (trabajador.aux_cargos == null || horas == null ) {
                suma += 0;
            } else {
                suma += trabajador.aux_cargos * this.transformStringToNumber(horas);
            }
        }
        return suma;
    }


    public tipoTarea(tarea: string): void {
        this.showTarea = false;
        this.showTareaFito = false;
        this.showTareaFerti = false;
        if ( tarea == null || tarea.length === 0) {
            this.showTarea = true;
            return;
        }

        if ( tarea === 'Tareas fitosanitarias' ) {
            this.showTareaFito = true;
            return;
        }
        
        if ( tarea === 'Tareas fertilizantes' ) {
            this.showTareaFerti = true;
            return;
        }
        this.showTarea = true;
        return;
    }


    public generateWorkerReport(): void {
        const params: { id_trabajador?: number; mes?: number, any?: number } = {};
        const selectedTrabajador = this.selectedTrabajadorControl.value;
        const selectedMes = this.generarMesControl.value;
        const selectedAnyo = this.generarAnyoControl.value;

        if (this.appName === 'detorres') {
            params['id_trabajador'] = +(selectedTrabajador?.id ?? 0);
        } else {
            params['mes'] = selectedMes.getMonth() + 1;
        }

        params['any'] = selectedAnyo.getFullYear();
        const mes = selectedMes.toLocaleString('es-ES', { month: 'long' });

        this.getInformesRequest.safePerform(params as any);
        this.getInformesRequest.response((costes: any[]) => {
            let columns: string[] = [];
            const table: any[][] = [];

            if (this.appName === 'detorres') {
                columns = ['Mes', 'Coste (€)/Hora', 'Horas', 'Coste Total (€)'];
            } else {
                columns = ['Finca', 'Empresa', 'Nóminas Tomega', 'Nóminas Palau Citrus', 'Total'];
            }

            const headerRow: any = columns.map(col => ({
                text: col,
                bold: true,
                alignment: 'center',
                fillColor: '#f0f0f0'
            }));
            
            table.push(headerRow);

            const totalCols = new Array(columns.length).fill(0); // inicialitzar sumatoris

            costes.forEach((coste) => {
                let rawRow: (string | number)[] = [];

                if (this.appName === 'detorres') {
                    rawRow = [
                        coste?.mes ?? '',
                        coste?.precio_hora ?? '',
                        coste?.hores_totals_formatejades ?? '',
                        coste?.total_facturat ?? ''
                    ];
                } else {
                    rawRow = [
                        coste?.finca ?? '',
                        coste?.empresa ?? '',
                        coste?.nomina_tomega ?? '',
                        coste?.nomina_palau_citrus ?? '',
                        coste?.total_finca ?? ''
                    ];
                }

                // Formatar i centrar totes les cel·les
                const formattedRow = rawRow.map((val, i) => {
                    const isEuro = i >= 2; // assumim que a partir de la columna 2 són imports
                    const parsed = parseFloat(val?.toString().replace(',', '.'));
                    const isNumeric = !isNaN(parsed);

                    let text = val;

                    if (isNumeric && isEuro) {
                        text = parsed.toLocaleString('es-ES', { minimumFractionDigits: 2 }) + ' €';
                    }

                    return {
                        text: text ?? '',
                        alignment: 'center',
                    };
                });


                table.push(formattedRow);

                // Acumular totals (a partir de col 2)
                rawRow.forEach((val, i) => {
                    if (i >= 2) {
                        const numeric = parseFloat(val.toString());
                        if (!isNaN(numeric)) {
                            totalCols[i] += numeric;
                        }
                    }
                });
            });


            // Afegir la fila de totals
            const totalRow: any[] = [];

            for (let i = 0; i < columns.length; i++) {
                if (i === 0) {
                    totalRow.push({
                        text: 'TOTAL',
                        alignment: 'center',
                        bold: true,
                        fillColor: '#eeeeee',
                        margin: [0, 4, 0, 4]
                    });
                } else if (i === 1) {
                    totalRow.push({ text: '', alignment: 'center' });
                } else {
                    const formatted = totalCols[i].toLocaleString('es-ES', {
                        minimumFractionDigits: 2
                    }) + ' €';
                    totalRow.push({
                        text: formatted,
                        alignment: 'center',
                        bold: true,
                        fillColor: '#eeeeee',
                        margin: [0, 4, 0, 4]
                    });
                }
            }



            table.push(totalRow);

            // Construir el PDF
            let tituloPDF = '';
            if (this.appName === 'detorres') {
                tituloPDF = `Informe del Trabajador ${selectedTrabajador?.nombre ?? ''} (${selectedAnyo.getFullYear()})`;
            } else {
                tituloPDF = `Resumen Importe Nóminas_Fincas ${mes ?? ''} (${params['any'] ?? ''})`;
            }

            const docDefinition: any = {
                content: [
                    {
                        text: tituloPDF,
                        style: 'header',
                        margin: [0, 0, 0, 25]
                    },
                    {
                        table: {
                            headerRows: 1,
                            widths: ['*', '*', '*', '*', '*'],
                            body: table
                        },
                        layout: {
                            hLineWidth: function () { return 0.5; },
                            vLineWidth: function () { return 0.5; },
                            hLineColor: function () { return '#aaa'; },
                            vLineColor: function () { return '#aaa'; },
                            paddingLeft: () => 5,
                            paddingRight: () => 5,
                            fillColor: (rowIndex: number) => rowIndex === 0 ? '#eeeeee' : null
                        },

                    }
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        alignment: 'center'
                    }
                }
            };

            const fileName = this.appName === 'detorres'
                ? `informe_${selectedTrabajador?.nombre ?? ''}_(${selectedAnyo.getFullYear()}).pdf`
                : `informe_nominas_fincas_${mes}_(${selectedAnyo.getFullYear()}).pdf`;

            pdfMake.createPdf(docDefinition).download(fileName);
            this.getInformesRequest.unsuscribe();
        });
    }


    public generateMachineryReport() {
        this.getInformesMaquinariaRequest.safePerform();
        this.getInformesMaquinariaRequest.response((costes: any[]) => {
            const columns = ['Maquinaria', 'Fecha de Adquisición', 'Horas de Uso', 'Vida Útil Estimada (Horas)', 'Vida Útil Restante (%)'];
            const table: string[][] = [];
            
            // Afig primer fila amb els encapçalaments
            table.push(columns);
        
            // Afig dades
            costes.forEach((coste) => {
                table.push([
                    coste?.nombre ?? '',
                    coste?.fecha_adquisicion ?? '',
                    coste?.horas_fito ?? '',
                    coste?.vida_util ?? '',
                    coste?.vida_util_restante
                ]);
            });
        
            const docDefinition: any = {
                content: [
                    { 
                        text: 'Informe de Vida Útil de la Maquinaria', 
                        style: 'header', 
                        margin: [0, 0, 0, 20] 
                    },
                    {
                        table: {
                            headerRows: 1,
                            widths: ['*', '*', '*', '*', '*'],
                            body: table
                        },
                        layout: 'lightHorizontalLines'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        alignment: 'center'
                    }
                }
            };
        
            pdfMake.createPdf(docDefinition).download('informe_vida_util_maquinaria.pdf');
            this.getInformesMaquinariaRequest.unsuscribe();
        });
    }
}